export const USER_TYPES = {
  ADMIN: 'ADMIN',
  CONTRACTOR: 'CONTRACTOR',
  SUPERVISOR: 'SUPERVISOR',
  ASSIGNOR: 'ASSIGNOR',
};
